import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppMenuitem } from './app.menuitem';

@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule],
    template: `<ul class="layout-menu">
        @for (item of model; track item.label) {
            @if (!item.separator) {
                <li app-menuitem [item]="item" [root]="true"></li>
            } @else {
                <li class="menu-separator"></li>
            }
        }
    </ul> `
})
export class AppMenu {
    model: any[] = [
        {
            label: 'Dashboards',
            icon: 'pi pi-chart-bar',
            items: [
                {
                    label: 'Ejecutivo',
                    icon: 'pi pi-fw pi-chart-line',
                    routerLink: ['/dashboards/ejecutivo']
                },
                {
                    label: 'Operaciones',
                    icon: 'pi pi-fw pi-list-check',
                    routerLink: ['/dashboards/operaciones']
                },
                {
                    label: 'Usuarios',
                    icon: 'pi pi-fw pi-users',
                    routerLink: ['/dashboards/usuarios']
                }
                // TODO: 'Facturación' tab (future spec)
            ]
        },
        {
            label: 'Datos',
            icon: 'pi pi-database',
            items: [
                {
                    label: 'Emisiones',
                    icon: 'pi pi-fw pi-file',
                    routerLink: ['/emissions']
                },
                {
                    label: 'Endosos',
                    icon: 'pi pi-fw pi-arrow-right-arrow-left',
                    routerLink: ['/endorsements']
                },
                {
                    label: 'Usuarios',
                    icon: 'pi pi-fw pi-users',
                    routerLink: ['/users']
                },
                {
                    label: 'Organizaciones',
                    icon: 'pi pi-fw pi-building',
                    routerLink: ['/organizations']
                }
                // TODO: próximas entidades en esta sección:
                // - Entidades (depositantes, depósitos, aseguradoras) agregadas por taxId
            ]
        },
        {
            label: 'Facturación',
            icon: 'pi pi-receipt',
            items: [
                {
                    label: 'Cargos',
                    icon: 'pi pi-fw pi-list',
                    routerLink: ['/billable-items']
                },
                {
                    label: 'Facturas',
                    icon: 'pi pi-fw pi-file',
                    routerLink: ['/invoices']
                },
                {
                    label: 'Cobranza',
                    icon: 'pi pi-fw pi-wallet',
                    routerLink: ['/collections']
                },
                {
                    label: 'Clientes',
                    icon: 'pi pi-fw pi-id-card',
                    routerLink: ['/billing-profiles']
                }
            ]
        },
        {
            label: 'Catálogo',
            icon: 'pi pi-tags',
            items: [
                {
                    label: 'Estructura',
                    icon: 'pi pi-fw pi-sitemap',
                    routerLink: ['/products']
                },
                {
                    label: 'Sin clasificar',
                    icon: 'pi pi-fw pi-question-circle',
                    routerLink: ['/products/unclassified']
                }
            ]
        }
        // TODO: futuras secciones cuando se implementen:
        // - Onboarding institucional
        // - Integración ARCA
        // - Reportes
    ];
}
